import { IOption } from '@/interfaces';

import { FieldChanged, UserStatus } from '@/features/user-management/enums';
import { getFieldChangedLabel, getUserStatusLabel } from '@/features/user-management/utils';

export const USER_STATUS_OPTIONS: IOption[] = [
  {
    label: getUserStatusLabel(UserStatus.Pending),
    value: UserStatus.Pending.toString(),
  },
  {
    label: getUserStatusLabel(UserStatus.Active),
    value: UserStatus.Active.toString(),
  },
  {
    label: getUserStatusLabel(UserStatus.Inactive),
    value: UserStatus.Inactive.toString(),
  },
];

export const ALL_FIELD_CHANGED_OPTION: IOption = {
  label: 'All Field Changed',
  value: 'all_field_changed',
};

export const FIELD_CHANGED_OPTIONS: IOption[] = [
  {
    label: ALL_FIELD_CHANGED_OPTION.label,
    value: ALL_FIELD_CHANGED_OPTION.value,
  },
  {
    label: getFieldChangedLabel(FieldChanged.Status),
    value: FieldChanged.Status.toString(),
  },
  {
    label: getFieldChangedLabel(FieldChanged.Role),
    value: FieldChanged.Role.toString(),
  },
];
